import CrewListContainer from './CrewListContainer'

const CrewList = () => <CrewListContainer/>

export default CrewList